import * as React from "react";
import { ProductTile } from "@arctheme-components/ecommerce/Product/ProductTile";

export function HeaderSearchNoResults({ settings, query, onClose }) {
  const recommendedProducts = settings?.no_results?.product_list || settings?.section_settings?.product_list || [];
  
  return (
    <div className="header-search-no-results p-4">
      <div className="flex w-full justify-between items-center mb-4">
        <p className="font-medium text-lg">
          Search Results (0)
        </p>

        <div 
          className="lg:hidden cursor-pointer header-search-no-results__toggle"
          onClick={onClose}
        >
          <span className="sr-only">Close</span>
          <i className="icon icon-x-thin text-[20px]"></i>
        </div>
      </div>

      <p className="text-lg font-light mb-6">
        {settings?.no_results?.title?.replace("&#39;", "'") || `No results found for "${query}"`}
      </p>
      
      {recommendedProducts?.length > 0 && (
        <>
          <p className="font-medium mb-3">Recommended Products</p>
          <div className="header-search-no-results__products overflow-x-auto">
            <div className="flex gap-4">
              {recommendedProducts.map((product, index) => (
                <div className="min-w-[180px] max-w-[240px]" key={`recommended-${index}`}>
                  <ProductTile settings={settings} product={product} siblings={undefined} />
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
